

export default function appStatusFetchRetry(fetch, url, options, retryOptions) {

  const defaultConfiguration = {
    retries: 12,
    retryDelay: 1000
  };

  const { retries, retryDelay } = Object.assign({}, defaultConfiguration, retryOptions);

  let retry = (wrappedFetch, retryCounter, resolve, response) => {
    if (retryCounter > 0) {
      setTimeout(() => wrappedFetch(--retryCounter), retryDelay);
    } else {
      response.retryTimeout = true;
      resolve(response);
    }
  };

  return new Promise(resolve => {
    let wrappedFetch = (retryCounter) => {
      fetch(url, options)
        .then((response) => {
          if (response.status === 401 || response.status === 404) {
            retry(wrappedFetch, retryCounter, resolve, response);
          } else {
            response.clone().json().then((data) => {
              if (data.applicationStatus === 'SUBMITTED' && data.pageId !== 'verid') {
                retry(wrappedFetch, retryCounter, resolve, response);
              } else {
                resolve(response);
              }
            });
          }
        })
        .catch((error) => {
          retry(wrappedFetch, retryCounter, resolve, error);
        });
    };

    wrappedFetch(retries);
  });
};
